export function LogoMark({ className = "h-10 w-10" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect x="0.75" y="0.75" width="62.5" height="62.5" rx="12" fill="#0A0A0C" stroke="#C5A059" strokeWidth="1.5" />
      <rect x="6.5" y="6.5" width="51" height="51" rx="7" fill="none" stroke="#C5A059" strokeWidth="1" opacity="0.45" />
      <text
        x="32"
        y="43"
        textAnchor="middle"
        fontFamily="Cormorant Garamond, Georgia, serif"
        fontSize="30"
        fontWeight="500"
        fill="#C5A059"
        letterSpacing="1"
      >
        SR
      </text>
    </svg>
  );
}

export default function Logo({ light = true }: { light?: boolean }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark className="h-10 w-10 shrink-0" />
      <span className="leading-none">
        <span className={`block font-serif text-[22px] tracking-wide ${light ? "text-zinc-100" : "text-obsidian"}`}>
          Shriya Redkar
        </span>
        <span className="mt-1 block font-display text-[9px] font-semibold uppercase tracking-widest2 text-gold">
          Interiors · Est. 19 Yrs
        </span>
      </span>
    </span>
  );
}
